import { icons } from "./icons";

export const orders = [
  {
    icon: icons.serviceBreak,
    name: "Brake fluid change"
  },
  {
    icon: icons.serviceDiag,
    name: "Diagnostics"
  },
  {
    icon: icons.serviceWash,
    name: "External Washing"
  }
]